<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <section class="card  bg-white p-2" style="width: 120%" v-if="isShowCloseInInfo(scenicArea)">
      <div class="row d-flex align-items-center">
        <div class="col-xl-6 d-flex col-12 text-align-2 ">
          <label class="custom-control border-switch mb-0" for="customSwitch" style="cursor: not-allowed;">
            <input type="checkbox" class="border-switch-control-input"  id="customSwitch" v-model="isSenicAreaWarning" disabled>
            <span class="border-switch-control-indicator"></span>
            氣象預警 
          </label>
          <label class="custom-control border-switch mb-0" for="customSwitch2">
            <input type="checkbox" class="border-switch-control-input"  id="customSwitch2" v-model="isSenicAreaControl" @change="changeControlStatus" 
                  :disabled='isControlSwitchDisable' :style="[isControlSwitchDisable? 'cursor: not-allowed;' : '']">
            <span class="border-switch-control-indicator"></span>
            啟動管制
          </label>
        </div>
        <div class="col-xl-6 text-align-2 font-weight-bold" v-if="isSenicAreaControl">
          {{isSenicAreaControl? '景區管制: 累計進入海岸線' : '景區管制:'}}<b :class="{h5: true,  'text-red':isSenicAreaControl }"> {{stdViolation.count? 'stdViolation.count' : '0'}}</b> 人<br>
          最近1筆:<b :class="{h5: true,  'text-red':isSenicAreaControl }">{{stdViolation.dt? getTime(stdViolation) : ''}}</b>
        </div>
        <div class="col-xl-6 text-align-2 font-weight-bold" v-else>
          景區管制:<b class="h5"> {{'- - -'}}</b> 人<br>
          最近1筆:<b class="h5">{{'- - -'}}</b>
        </div>
      </div>
    </section>  

    <div class="row pt-2 equal-cols" style="width: 120%" >
      <div :class="[isShowWeatherInfo(scenicArea)? 'col-xl-6 col-12': 'col-xl-12 col-12']">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">景區人車流</h2>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-xl-8 col-lg-6 col-md-12 col-12">
                <section class="card card-featured-left card-featured-info mb-1" v-for="(v, i) in vehicleAmount" :key="i">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col widget-summary-col-icon">
                        <div class="summary-icon bg-primary"><i :class="v.icon"></i></div>
                      </div>
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">{{ v.name }}</h4>
                          <div class="d-flex">
                            <div class="w-100">
                              <ul class="list-inline font-weight-bold mb-0 pb-0">
                                <li class="list-inline-item">停車率 
                                  <strong class="amount">{{vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[v.keyLV1] || vehicleAndPeopleData[v.keyLV1][v.keyRatio] <0 ? 
                                    v.conent : (Math.round(vehicleAndPeopleData[v.keyLV1][v.keyRatio] * 100)) + v.ratioUnit}}
                                  </strong>
                                </li>
                                <li class="list-inline-item">總車位
                                  <strong class="amount">{{vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[v.keyLV1] ? 
                                    v.conent : vehicleAndPeopleData[v.keyLV1][v.keySpace]}}
                                  </strong>
                                </li>
                                <li class="list-inline-item">在園車輛
                                  <strong class="amount">{{vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[v.keyLV1] || vehicleAndPeopleData[v.keyLV1][v.keyInsite] < 0 ?  
                                    v.conent : vehicleAndPeopleData[v.keyLV1][v.keyInsite]}}
                                  </strong>
                                </li>
                              </ul>
                            </div>
                            <div class="col-5">
                              <apexchart type="donut" width="100" :options="chartOptions" style="padding-top: 12%" v-if="!(vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[v.keyLV1] || vehicleAndPeopleData[v.keyLV1][v.keySpace] === 0 || vehicleAndPeopleData[v.keyLV1][v.keyInsite] < 0)"
                                    :series="vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[v.keyLV1] ?   [0, 1] : vehicleAndPeopleData[v.keyLV1][v.keySeries]">
                              </apexchart>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-xl-4 col-lg-6 col-md-12 col-12">
                <section class="card card-featured-left card-featured-info mb-1" v-for="(p, i) in peopleAmount" :key="i">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col widget-summary-col-icon">
                        <div class="summary-icon bg-primary"><i :class="p.icon"></i></div>
                      </div>
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h2 class="title font-weight-bold">{{ p.name }}</h2>
                          <div class="info"><strong class="amount">{{ vehicleAndPeopleData === null || vehicleAndPeopleData === undefined || !vehicleAndPeopleData[p.keyLV1] || vehicleAndPeopleData[p.keyLV1][p.keyLV2] < 0? p.conent : vehicleAndPeopleData[p.keyLV1][p.keyLV2] + p.unit }}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-xl-6 col-12" v-if="isShowWeatherInfo(scenicArea)">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">氣象資訊</h2>
          </header>
          <div class="card-body">
            <div class="col-12  px-0">
              <table class="table table-responsive-md table-striped mb-0 bg-white text-center">
                <thead class="bg-teal text-white">
                  <tr>
                    <th>項目</th>
                    <th>級別</th>
                    <th>擷取時間</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(weather, i) in weatherPlate" :key="i">
                    <td :class="checkWeatherAlert(weather)">{{ weather.name }}</td>
                    <td :class="checkWeatherAlert(weather)">
                      {{ 
                          (!cwbWeatherData || cwbWeatherData[weather.key] === -99 || cwbWeatherData[weather.key] === ''|| cwbWeatherData[weather.key] === 0)? '-' :
                            cwbWeatherData[weather.key] + weather.unit 
                      }}
                      <!-- <i v-if='checkWeatherAlert(weather) === weatherCSS.danger' class="fas fa-exclamation-circle"></i> -->
                    </td>
                    <td :class="checkWeatherAlert(weather)">{{updateTime}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      <!-- <div class="col-md-12">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">遊客中心人流</h2>
          </header>
          <div class="card-body">
            <div class="row  equal-cols">
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1 ">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h2 class="title font-weight-bold">進場人數</h2>
                          <div class="info"><strong class="amount">35</strong></div>
                        </div>
                      </div>\services
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1 ">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">離場人數</h4>
                          <div class="info"><strong class="amount">145</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">場內人數</h4>
                          <div class="info"><strong class="amount">38</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">容流人數管制量</h4>
                          <div class="info"><strong class="amount">3765</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title2">男性 <span class="float-right"><strong class="amount text-right">654</strong></span></h4>
                          <h4 class="title2">女性 <span class="float-right"><strong class="amount text-right">88</strong></span></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title2">老 <span class="float-right"><strong class="amount text-right">63</strong></span></h4>
                          <h4 class="title2">中 <span class="float-right"><strong class="amount text-right">67</strong></span></h4>
                          <h4 class="title2">青 <span class="float-right"><strong class="amount text-right">21</strong></span></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div> -->
      <div class="col-md-12">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">即時設備地圖</h2>
          </header>
          <div class="card-body"> 
            
            <!--Google map-->
            <div id="map-container-google-1" class="z-depth-1-half map-container" >
              <map-map :scenicAreaId='scenicAreaId'></map-map>
            </div>
          </div>
        </section>
      </div>
    </div>

    <section class="card mb-2" style="width: 120%">
      <header class="card-header bg-info text-white">
        <div class="card-actions"><a href="#" class="card-action card-action-toggle" data-card-toggle=""></a></div>
        <h2 class="card-title">統計圖</h2>
      </header>
      <div class="card-body">
        <div class="tabbed">
          <input type="radio" id="tab1a" name="css-tabs" @click="clickChartTab" checked="">
          <input type="radio" id="tab2a" name="css-tabs" @click="clickChartTab">
          <ul class="tabs">
            <li class="tab">
              <label for="tab1a">本日車流</label>
            </li>
            <li class="tab">
              <label for="tab2a">本日人流</label>
            </li>
          </ul>
          <div class="tab-content">
            <div class="border h3 text-center" style="min-height: 200px">
                  <div id="chart">
                    <apexchart
                      type="line"
                      height="200"
                      :options="carCountSetting"
                      :series="vehicleTypeCountData"
                    ></apexchart>
                  </div>
                </div>
          </div>
          <div class="tab-content">
            <div class="border h3 text-center" style="min-height: 200px">
                <div id="chart">
                    <apexchart
                      type="line"
                      height="200"
                      :options="peopleCountSetting"
                      :series="peopleCountData"
                    ></apexchart>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import {mapState, mapGetters} from 'vuex'
import { authentication, my } from "resource";
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import ApexchartObject from '../../utils/apexchartObject/stdApexchart'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import MapMap from '../map/index'

export default {
  name: "Home",
  components: {
    apexchart: VueApexCharts,
    MapMap
  },
  data() {
    return {
      accountName: '',
      dataInterval: null,
      scenicAreaId: parseInt(Utils.getScenicAreaIdFromUrlPath()),
      scenicArea: {},
      isControlSwitchDisable: false,
      isSenicAreaWarning: false,
      isSenicAreaControl: false,
      violationQueryTime: '',
      cwbWeatherData: {},
      disasterSettingData: {},
      updateTime: '',
      weatherCSS: {
        normal: '',
        alert: 'text-orange',
        danger: 'text-red h5 font-weight-bold'
      },
      weatherPlate: [
        { name: "風力", unit: "級", key: CONST.HOME_PAGE_WEATHER_ITEM.WIND_POWER, id: 6},
        { name: "陣風", unit: "級", key: CONST.HOME_PAGE_WEATHER_ITEM.GUST, id: 7},
        { name: "浪高", unit: "公尺",key: CONST.HOME_PAGE_WEATHER_ITEM.WAVE, id: 8},
        { name: "長浪", unit: "", key: CONST.HOME_PAGE_WEATHER_ITEM.SWELL, id: 9},
        { name: "地震", unit: "級", key: CONST.HOME_PAGE_WEATHER_ITEM.EARTHQUAKE, id: 10},
        { name: "颱風", unit: "", key: CONST.HOME_PAGE_WEATHER_ITEM.TYPHOON, id: 11},
        { name: "特報", unit: "", key: CONST.HOME_PAGE_WEATHER_ITEM.HEAVY_RAIN, id: 12},
      ],
      vehicleAndPeopleData: {},
      peopleAmount: [
        { name: "在園人數", icon: "fa fa-users", unit: '人', conent: "-", 
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.PEOPLE_FLOW_DATA, keyLV2: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.INSIDE_PEOPLE_FLOW
        },
        { name: "本日總人數", icon: "fa fa-users", unit: '人', conent: "-",
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.PEOPLE_FLOW_DATA, keyLV2: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.TOTALE_PEOPLE_FLOW
        },
        { name: "在園車輛", icon: "fa fa-car", unit: '輛', conent: "-", 
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA, keyLV2: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.TOTALE_INSITE_CAR_FLOW
        },
        { name: "本日總車輛", icon: "fa fa-car", unit: '輛', conent: "-", 
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA, keyLV2: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.TOTALE_VEHICLE_FLOW
        },
      ],
      vehicleAmount: [
        { name: "大型車", icon: "fa fa-bus", insite: 0, space: 0, ratio: 0, ratioUnit: '%',  conent: "-",
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA,
          keyInsite: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_INSITE_FLOW,
          keySpace: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_PARKING_SPACE,
          keyRatio: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_PARKING_USING_RATIO,
          keySeries: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_SERIES
        },
        { name: "小型車", icon: "fa fa-car", insite: 0, space: 0, ratio: 0, ratioUnit: '%',  conent: "-",
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA,
          keyInsite: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_INSITE_FLOW,
          keySpace: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_PARKING_SPACE,
          keyRatio: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_PARKING_USING_RATIO,
          keySeries: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_SERIES
        },
        { name: "機車", icon: "fa fa-motorcycle", insite: 0, space: 0, ratio: 0, ratioUnit: '%',  conent: "-",
          keyLV1: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA,
          keyInsite: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_INSITE_FLOW,
          keySpace: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_PARKING_SPACE,
          keyRatio: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_PARKING_USING_RATIO,
          keySeries: CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTO_SERIES
        },
      ],
      chartOptions: ApexchartObject.vehicleDonutOption,
      vehicleTypeCountData: [],
      initPeopleCountData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      peopleCountData: [
        {
          name: "人數",
          data: [0, 0, 0, 24, 33, 26, 21, 20, 0, 0, 0, 0],
        },
      ],
      carCountSetting: ApexchartObject.carCountOption,
      peopleCountSetting: ApexchartObject.peopleCountOption,
    };
  },
  computed: { 
    ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapState('elasticMonitor', {vehicleAndPeople: 'vehicleAndPeople'}),
    ...mapState('controlHistory', {allControllHistory: 'allControllHistory'}),
    ...mapState('violation', {stdViolation: 'stdViolation'}),
    // ...mapGetters('scenicArea', {scenicAreaList: 'getAllScenicArea'})  
  },
  watch: {
    '$route'(to, from) {
      this.scenicAreaId = parseInt(Utils.getScenicAreaIdFromUrlPath())
    },

    async scenicAreaId() {
      this.scenicArea = this.scenicAreaList.find(s => s.id === this.scenicAreaId)
      this.getAllData()
      this.getDisasterSettingData()
    },

    isSenicAreaControl() {
      if(this.isSenicAreaControl) {
        this.getStdViolationCount()
      }
    }
  },
  methods: {
    getTime: function (item) {
      return moment(item.dt).format('YYYY/MM/DD HH:mm')
    },

    isShowWeatherInfo(sc) {
      if(Utils.isEmptyObject(this.scenicArea)) { 
        // 第一次進入儀錶板不會觸發scenicAreaId watch，所以 scenicArea會是空的
        this.scenicArea = this.scenicAreaList.find(s => s.id === this.scenicAreaId)
      }

      return Utils.isShowWeatherScenicArea(sc)
    },

    isShowCloseInInfo(sc) {
      return Utils.isShowCloseInScenicArea(sc)
    },

    async getStdViolationCount() {
      const condition = {
        startTime: this.violationQueryTime,
        endTime: moment().format(),
        scenicAreaId: this.scenicAreaId,
        type: 4
      }

      await this.$store.dispatch('violation/getStdDashBoradViolation', condition)
    },
    clickChartTab() {
      // workaround for VueApexCharts open issue: apexchart in tab-content is disapeared
      window.dispatchEvent(new Event('resize'))
    },
    checkSwitchsStatus() {
      const controlData = this.$store.getters['controlHistory/getScenicControlData'](this.scenicAreaId)
      this.isSenicAreaWarning = controlData[CONST.CONTROL_TYPE.WARING]? controlData[CONST.CONTROL_TYPE.WARING] : false
      this.isSenicAreaControl = controlData[CONST.CONTROL_TYPE.CONTROL]? controlData[CONST.CONTROL_TYPE.CONTROL] : false
      this.violationQueryTime = controlData.time? controlData.time : null
    },
    async changeControlStatus() {
      this.isControlSwitchDisable = true // 避免短時間連續修改
      const data = {
        scenicAreaId: this.scenicAreaId,
        controlHistoryType: CONST.CONTROL_TYPE.CONTROL,
        controlswitch: this.isSenicAreaControl,
        fillAccount: this.accountName
      }

      await this.$store.dispatch('controlHistory/postControllHistory', data)
      this.isControlSwitchDisable = false
    },
    checkWeatherAlert(weather) {
      if(Utils.isEmptyObject(this.cwbWeatherData)) {
        return this.weatherCSS.normal
      }

      const target = CONST.CWB_DISASTER_SETTING.find(d => d.id === weather.id)
      if(Utils.isEmptyObject(target)) {
        return this.weatherCSS.normal
      }
      
      let css = ''
      switch(target.id) {
        case 6: // 風力 陣風 浪高
        case 7:
        case 8:
          if(this.cwbWeatherData[weather.key] < target.alert) {
            css = this.weatherCSS.normal
          } else if(this.cwbWeatherData[weather.key] < target.danger) {
            css = this.weatherCSS.alert
          } else {
            css = this.weatherCSS.danger
          }
          break
        
        case 10: // 地震
          if(this.cwbWeatherData[weather.key] === target.normal) {
            css = this.weatherCSS.normal
          } else {
            css = this.weatherCSS.danger
          }
          break

        case 9: // 長浪  颱風
        case 11:
          if(this.cwbWeatherData[weather.key] === target.normal) {
            css = this.weatherCSS.normal
          } else {
            css = this.weatherCSS.danger
          }
          break
        case 12:
          if(Utils.isEmptyString(this.cwbWeatherData[weather.key]) || this.cwbWeatherData[weather.key].length === target.normal) {
            css = this.weatherCSS.normal
          } else if(this.cwbWeatherData[weather.key].length <= target.alert){
            css = this.weatherCSS.alert
          } else {
            css = this.weatherCSS.danger
          }
          break  
      }

      return css 
    },
    async getDisasterSettingData() {
      await this.$store.dispatch('disasterSetting/getDisasterSettingByArea', {id: this.scenicAreaId})
      this.disasterSettingData = this.$store.getters['disasterSetting/getDisasterSettingByArea'](this.scenicAreaId)
    },

    async getAllWeather() {
      await this.$store.dispatch('weatherMonitor/getWeather', {id: this.scenicAreaId})
      this.cwbWeatherData = this.$store.getters['weatherMonitor/getWeather']
    },

    async getVehicleAndPeople() {
      await this.$store.dispatch('elasticMonitor/getVehicleAndPeople', {scenicAreaId: this.scenicAreaId})
      this.vehicleAndPeopleData = this.$store.getters['elasticMonitor/getSingleVehicleAndPeople'](this.scenicAreaId)
    },

    async getAllControlHistory() {
      await this.$store.dispatch('controlHistory/getAllControllHistory')
      this.checkSwitchsStatus()
    },

    async getVehicleCountPerDay() {
      const vehicleInList = this.$store.getters['getScenicAreaVehicleInCamera']

      this.vehicleTypeCountData = []
      let peopleTotleCount = this.initPeopleCountData
      const st = moment().startOf('d').valueOf()
      const et = moment().valueOf()
      // const st = moment('20220629').startOf('d').valueOf()
      // const et = moment('20220629').endOf('d').valueOf()
      let filterStreamingIds = vehicleInList.map(t => t.streamId)
      const carTypeEnumList = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
      const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']

      for(let i = 0 ; i < carTypeEnumList.length ; i++) {
        const condition = {
          streamingIds: filterStreamingIds,
          startTime: st,
          endTime: et,
          interval: '2h',
          objectTypes: [carTypeEnumList[i].enumType],
          dataType: ''
        }

        const vehicleCountResult = await getCountPerHour(condition)
        const hours = 12 // 一天 2小時為一單位 0~24 13格
        const timestamps = Array.from({ length: hours }).map((v, i) => moment(st).add(i+i, 'h').valueOf())
        const carTotalCount = timestamps.map(t => {
          return vehicleCountResult[t] ? vehicleCountResult[t] : 0
        })

        const peopleCount = carTotalCount.map((c, index) => {
          const date = moment(timestamps[i]).startOf('day').format().split('+')[0]
          return Math.round(c*(holidayMap.get(date)? carTypeEnumList[i].holidayWeight :  carTypeEnumList[i].weight) + peopleTotleCount[index])
        })

        peopleTotleCount = peopleCount
        this.vehicleTypeCountData.push({name: carTypeEnumList[i].description, data: carTotalCount})
      }

      this.peopleCountData[0].data = peopleTotleCount
      this.carCountSetting = {...this.carCountSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
      this.peopleCountSetting = {...this.peopleCountSetting}
    },

    async getAllData() {
      if(!window.location.href.includes('stpDashboard')) {
        console.log('std get all return')
        return 
      }

      this.updateTime = moment().format('YYYY/MM/DD HH:mm')
      await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', {id: this.scenicAreaId})
      await this.getAllControlHistory()
      await this.getVehicleAndPeople()
      await this.getAllWeather()
      await this.getVehicleCountPerDay()
      await this.$store.dispatch('toiletMgt/getTioletErrorDevice')
      await this.$store.dispatch('weatherStation/updateSanxianStationData') // 這樣不用每個地圖都去呼叫這個api
      await this.$store.dispatch('emergencyEvent/getEmergencyButton')
    },
  },
  async mounted() {
    // await this.$store.dispatch('videoCamera/getCCTV')
    this.getAllData()
    this.getDisasterSettingData()
    this.dataInterval = setInterval(async () => {
      this.getAllData()
    }, CONST.REFRESH_DAT_TIMER_MIN)

    my.info().then(a => {
      this.accountName = a.body.name;
    });
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval)
    this.dataInterval = null
  }
};
</script>
